<template>
  <div>

    <v-row>

      <v-col cols="6" sm="6">
        <v-card class="mx-auto">
          <p class="text-center text-subtitle-1 text--secondary font-weight-bold">Сетевой комплекс</p>
          <p class="text-center text-h4 text--secondary font-weight-bold">{{powerGridComplexCount}}</p>
          <v-card-actions>
            <v-btn x-small color="info" dark @click="$emit('powerGridComplexList')" class="rounded-lg">
              Список
            </v-btn>
            <v-spacer />
            <v-btn x-small color="info" dark @click="$emit('powerGridComplexItem')" class="rounded-lg">
              <!-- <v-icon x-small>mdi-plus</v-icon> -->
              Создать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="6" sm="6">
        <v-card class="mx-auto">
          <p class="text-center text-subtitle-1 text--secondary font-weight-bold">Подстанции</p>
          <p class="text-center text-h4 text--secondary font-weight-bold">{{privateTransformerSubstationCount}}</p>
          <v-card-actions>
            <v-btn x-small color="info" dark @click="$emit('privateTransformerSubstationList')" class="rounded-lg">
              Список
            </v-btn>
            <v-spacer />
            <v-btn x-small color="info" dark @click="$emit('privateTransformerSubstationItem')" class="rounded-lg">
              Создать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

    </v-row>

    <v-row>

      <v-col cols="6" sm="6">
        <v-card class="mx-auto">
          <p class="text-center text-subtitle-1 text--secondary font-weight-bold">Воздушные линии</p>
          <p class="text-center text-h4 text--secondary font-weight-bold">{{airLineCount}}</p>
          <v-card-actions>
            <v-btn x-small color="info" dark @click="$emit('airLineList')" class="rounded-lg">
              Список
            </v-btn>
            <v-spacer />
            <v-btn x-small color="info" dark @click="$emit('airLineItem')" class="rounded-lg">
              Создать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="6" sm="6">
        <v-card class="mx-auto">
          <p class="text-center text-subtitle-1 text--secondary font-weight-bold">Опоры</p>
          <p class="text-center text-h4 text--secondary font-weight-bold">{{pillarCount}}</p>
          <v-card-actions>
            <v-btn x-small color="info" dark @click="$emit('pillarList')" class="rounded-lg">
              Список
            </v-btn>
            <v-spacer />
            <v-btn x-small color="info" dark @click="$emit('pillarItem')" class="rounded-lg">
              Создать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

    </v-row>

    <v-row>

      <v-col cols="6" sm="6">
        <v-card class="mx-auto">
          <p class="text-center text-subtitle-1 text--secondary font-weight-bold">Кабельные линии</p>
          <p class="text-center text-h4 text--secondary font-weight-bold">{{cableLineCount}}</p>
          <v-card-actions>
            <v-btn x-small color="info" dark @click="$emit('cableLineList')" class="rounded-lg">
              Список
            </v-btn>
            <v-spacer />
            <v-btn x-small color="info" dark @click="$emit('cableLineItem')" class="rounded-lg">
              Создать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="6" sm="6">
        <v-card class="mx-auto">
          <p class="text-center text-subtitle-1 text--secondary font-weight-bold">Щитовое оборуд.</p>
          <p class="text-center text-h4 text--secondary font-weight-bold">{{switchboardEquipmentCount}}</p>
          <v-card-actions>
            <v-btn x-small color="info" dark @click="$emit('switchboardEquipmentList')" class="rounded-lg">
              Список
            </v-btn>
            <v-spacer />
            <v-btn x-small color="info" dark @click="$emit('switchboardEquipmentItem')" class="rounded-lg">
              Создать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import common from "@/common";

export default {
  name: 'mainPage',

  props: {
    param: String,
  },

  created() {
    this.loadData()
  },


  data() {
    return {
      powerGridComplexCount: 0,
      privateTransformerSubstationCount: 0,
      airLineCount: 0,
      pillarCount: 0,
      cableLineCount: 0,
      switchboardEquipmentCount: 0,
    }
  },

  methods: {
    async loadData() {
      this.powerGridComplexCount = await common.getListLength('powerGridComplex')
      this.privateTransformerSubstationCount = await common.getListLength('privateTransformerSubstation')
      this.airLineCount = await common.getListLength('airLine')
      this.pillarCount = await common.getListLength('pillar')
      this.cableLineCount = await common.getListLength('cableLine')
      this.switchboardEquipmentCount = await common.getListLength('switchboardEquipment')
    }
  },

}
</script>
